import React, { FunctionComponent } from 'react';
import {
  NumberOfStayDays,
  NumberOfStayDaysWithFlight,
  NumberOfStayWrapper,
} from './StayTime.style';
import { pluralizeNights } from '@lt/components/utils/pluralizeUtils';

type Props = {
  nightsCount: number;
  originalNights: number;
};

export const StayTime: FunctionComponent<Props> = ({ nightsCount, originalNights }) => {
  return (
    <NumberOfStayWrapper>
      <NumberOfStayDays>
        {nightsCount} {pluralizeNights(nightsCount)}
      </NumberOfStayDays>
      {nightsCount !== originalNights && (
        <NumberOfStayDaysWithFlight>{originalNights} с перелётом</NumberOfStayDaysWithFlight>
      )}
    </NumberOfStayWrapper>
  );
};
